<template>
  <snackbar
    v-if="snackbarShow"
    :title="title"
    :subTitle="subTitle"
    :closeButtonText="'닫기'"
    :buttonText="'인증하기'"
    @close="snackbarClose"
    @complete="onComplete"
  />
</template>

<script>
import api from '../api';
import { setLocalStorageItem, getLocalStorageItem } from '@fastcampus/browser-util';
import Snackbar from './../snackbar/app';

const MIN_DESKTOP = 960;

export default {
  name: 'snackbar-app',
  components: {
    Snackbar,
  },
  data() {
    return {
      isEmailCertifiedNoti: false,
      showSnackbar: true,
      userProvider: '',
      isMobile: undefined,
      title: '',
      subTitle: '',
    };
  },
  computed: {
    snackbarShow() {
      return this.userProvider !== 'KAKAO' && this.showSnackbar && this.isEmailCertifiedNoti;
    },
  },
  watch: {
    isMobile() {
      this.title = this.isMobile ? '인증 절차가 완료되지 않은 계정입니다.' : '미인증 계정';
      this.subTitle = `${
        this.isMobile ? '' : '인증 절차가 완료되지 않은 계정입니다.<br />'
      }계정 보안 및 더 나은 서비스 제공을 위해 회원정보수정에서 이메일 인증을 완료해 주세요.`;
    },
  },
  created() {
    if (getLocalStorageItem('fc-access-token')) {
      this.getUserEmailCertified();
      if (getLocalStorageItem('fc-snackbar-date')) {
        let date = new Date();
        const limit = new Date(getLocalStorageItem('fc-snackbar-date'));
        if (date < limit) this.showSnackbar = false;
      }
    }
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  methods: {
    async getUserEmailCertified() {
      try {
        const {
          data: {
            data: { userEmailCertified, userProvider },
          },
        } = await api.getUser();
        if (!userEmailCertified) this.isEmailCertifiedNoti = true;
        if (userProvider) this.userProvider = userProvider;
      } catch (err) {
        console.log(err);
      }
    },
    snackbarClose() {
      this.showSnackbar = false;
      let now = new Date();
      let date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

      setLocalStorageItem('fc-snackbar-date', date);
    },
    onComplete() {
      window.location.href = '/me/info';
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth < MIN_DESKTOP;
    },
  },
};
</script>
